import { Container } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import "./ResCarousel.css"; // Import the CSS file

function ResCarousel() {
  return (
    <Container className="down-margin">
      <Carousel>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior1.jpg"
            alt="First slide"
            style={{ height: "auto", borderRadius: "20px" }}
          />
          <Carousel.Caption>
            <h3>First Resident</h3>
            <p>
              This is my 1st residential project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior2.jpg"
            alt="Second slide"
            style={{ height: "auto", borderRadius: "20px"  }}
          />
          <Carousel.Caption>
            <h3>Second Resident</h3>
            <p>
              This is my 2nd residential project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior3.jpg"
            alt="Third slide"
            style={{ height: "auto", borderRadius: "20px"  }}
          />
          <Carousel.Caption>
            <h3>Third Resident</h3>
            <p>
              This is my 3rd residential project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 carousel-image"
            src="/assets/images/exterior4.jpg"
            alt="Third slide"
            style={{ height: "auto", borderRadius: "20px"  }}
          />
          <Carousel.Caption>
            <h3>fourth Resident</h3>
            <p>
              This is my 4th residential project i made. this is located at ...
            </p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default ResCarousel;
